import { gql } from "apollo-boost";

export const SETS_LIB_MERGE = gql`
  mutation MutateSetLib(
    $setId: Int
    $setName: String
    $setDesc: String!
    $setPurpose: String
    $noOfSets: Int
    $noOfRep: Int
    $distance: Int
    $distanceSum: Int
    $stroke: String
    $tag: String
    $setInterval: Int
    $timePerDist: Int
    $timeTotal: Int
    $equipment: String
    $sportType: String
    $updateSource: String
    $userId: Int!
    $teamId: Int
  ) {
    setLibMerge(
      setlibData: {
        setId: $setId
        setName: $setName
        setDesc: $setDesc
        setPurpose: $setPurpose
        noOfSets: $noOfSets
        noOfRep: $noOfRep
        distance: $distance
        distanceSum: $distanceSum
        stroke: $stroke
        tag: $tag
        setInterval: $setInterval
        timePerDist: $timePerDist
        timeTotal: $timeTotal
        equipment: $equipment
        sportType: $sportType
        updateSource: $updateSource
        userId: $userId
        teamId: $teamId
      }
    ) {
      node {
        setId
        setName
        setDesc
        setPurpose
        noOfSets
        noOfRep
        distance
        distanceSum
        stroke
        tag
        setInterval
        timePerDist
        timeTotal
        equipment
        sportType
        updateSource
        userId
        teamId
      }
    }
  }
`;

export const SETS_LIB_DELETE = gql`
  mutation SetLibDelete($setId: Int!) {
    setLibDelete(setId: $setId) {
      status
    }
  }
`;
